<template>
	<v-parallax :height="$vuetify.breakpoint.smAndDown ? '450' : '700'" dark src="../../../assets/casino/MuayThai/carousels/MuayThaiChampion_bg.jpg">
		<v-row class="d-flex flex-column align-center pt-12">
			<v-img
				:width="$vuetify.breakpoint.sm ? '600' : '900'"
				transition="scroll-y-transition"
				class="banner-displayed"
				src="../../../assets/casino/MuayThai/carousels/MuayThaiChampion_LogoBehind.png"
			></v-img>
			<v-img
				:width="$vuetify.breakpoint.sm ? '600' : '900'"
				transition="scale-transition"
				class="banner-displayed"
				src="../../../assets/casino/MuayThai/carousels/MuayThaiChampion_Boxers.png"
			></v-img>
		</v-row>
	</v-parallax>
</template>

<script>
export default {
	data() {
		return {}
	},
}
</script>

<style lang="sass" scoped>
.banner-displayed
	display: flex
	align-content: flex-end
	position: absolute
</style>
